/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_TimezoneInputs */

const cs_settings_office_timezone = /** @type {(inputs: Settings_Office_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Časové pásmo`)
};

const en_settings_office_timezone = /** @type {(inputs: Settings_Office_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timezone`)
};

/**
* | output |
* | --- |
* | "Timezone" |
*
* @param {Settings_Office_TimezoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_timezone = /** @type {((inputs?: Settings_Office_TimezoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_TimezoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_timezone(inputs)
	return cs_settings_office_timezone(inputs)
});